import BaseApi from './base'

class ExcludedDomain extends BaseApi {
  getExcludedDomains = (query) => this.client.get(`excluded-domains?${query}`)

  addExcludedDomain = (data) => this.client.post(`excluded-domains`, data)

  updateExcludedDomain = ({ excludedDomainId, payload }) =>
    this.client.patch(`excluded-domains/${excludedDomainId}`, payload)

  deleteExcludedDomain = (excludedDomainId) =>
    this.client.delete(`excluded-domains/${excludedDomainId}`)
}

export default new ExcludedDomain()
